exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main-div[data-v-4c982b60]{background:#f8f8f8;position:relative}.main-card[data-v-4c982b60]{justify-content:center;text-align:center;align-items:center;height:100vh}.card-content[data-v-4c982b60]{padding:2rem}.card-content h2[data-v-4c982b60]{font-weight:500;line-height:1.2;color:#5e5873;font-size:1.75rem;margin-bottom:1rem}.card-content p[data-v-4c982b60]{font-size:1rem;color:#6e6b7b;margin-bottom:2rem}.error[data-v-4c982b60]{font-size:1rem;color:#fff!important;background-color:#000449ad;border-color:#000449ad;text-transform:none;padding:.6rem 1.5rem;margin-bottom:1.5rem;border-radius:4px}.card-content img[data-v-4c982b60]{margin-top:2rem}.error[data-v-4c982b60]:hover{box-shadow:0 8px 25px -8px #000449ad}.card-img[data-v-4c982b60]{position:absolute;top:1rem;left:2rem}.error-img img[data-v-4c982b60]{height:350px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c982b60","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/view/errorPage/error.vue
// module id = 1584
// module chunks = 0